import React, { createContext, useContext, useState } from "react";

const FilterContext = createContext();

export const useFilter = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
  const [filterVisible, setFilterVisible] = useState(false);

  const toggleFilter = () => setFilterVisible((prev) => !prev);

  return (
    <FilterContext.Provider value={{ filterVisible, toggleFilter }}>
      {children}
    </FilterContext.Provider>
  );
};
